/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Err_Tournament_Cannot_Set_Non_CompetingInputs */



/**
* | output |
* | --- |
* | "Cannot change proxy status after finals or once the tournament is finished" |
*
* @param {Err_Tournament_Cannot_Set_Non_CompetingInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const err_tournament_cannot_set_non_competing = /** @type {((inputs?: Err_Tournament_Cannot_Set_Non_CompetingInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Err_Tournament_Cannot_Set_Non_CompetingInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Impossible de modifier le statut de proxy après les finales ou une fois le tournoi terminé")
	if (locale === "es") return /** @type {LocalizedString} */ ("No se puede cambiar el estado de proxy después de las finales o una vez finalizado el torneo")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Não é possível alterar o status de proxy após as finais ou quando o torneio já está encerrado")
	if (locale === "it") return /** @type {LocalizedString} */ ("Impossibile modificare lo stato di proxy dopo le finali o una volta terminato il torneo")
	return /** @type {LocalizedString} */ ("Cannot change proxy status after finals or once the tournament is finished")
});